import formDelete from "./scripts/formDelete";
import homePageScroll from "./scripts/homePageScroll";
import languagePicker from "./scripts/languagePicker";
import removeNotifications from "./scripts/notifications";
import OrderCheckout from "./scripts/orderCheckout";
import OrderForm from "./scripts/orderForm";
import OrderSummaryTabs from "./scripts/orderSummaryTabs";
import serviceCards from "./scripts/readMore";

/**
 * datesToString converts all innerHTML of elements with class .date
 * into Date object
 */
const datesToString = async () => {
  const dates = document.querySelectorAll(".date");
  if (dates !== null) {
    dates.forEach(date => {
      const d = parseInt(date.innerHTML, 10);
      const dateObj = new Date(d * 1000);
      date.innerHTML = dateObj.toLocaleString();
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  datesToString();
  OrderForm();
  OrderCheckout();
  removeNotifications();
  OrderSummaryTabs();
  homePageScroll();
  languagePicker();
  formDelete();
  serviceCards();
});
